/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteTemplate.defs.js'
export * as $defs from './deleteTemplate.defs.js'
